"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpa = void 0;
var _config = require("@ori-appshell/config");
var _configurationManager = require("@ori/configuration-manager");
var _react = require("react");
const useSpa = ({
  name,
  environment,
  config = {},
  scriptOnly = false
}) => {
  const {
    clientAppsUrl
  } = (0, _configurationManager.useServiceUrls)(['clientApps']);
  return (0, _react.useMemo)(() => ({
    appUrl: `${clientAppsUrl}/${name}/`,
    src: (0, _config.createSpaEntryfileUrl)(name, environment, clientAppsUrl),
    config: JSON.stringify(config),
    id: {
      root: `${name}-root`,
      script: `${name}-script`
    },
    scriptOnly
  }), [clientAppsUrl, config, environment, name, scriptOnly]);
};
exports.useSpa = useSpa;
